import { Component, input, model, output } from '@angular/core';
import { ProfileDateFilterComponent } from '@shared/components/profile-date-filter/profile-date-filter.component';
import {
  EDateRangeType,
  IProfileDateFilterState,
} from '@shared/components/profile-date-filter/profile-date-filter.interface';
import { ICustomerDetailsFilter } from '../customer-details.interface';

@Component({
  imports: [ProfileDateFilterComponent],
  selector: 'app-customer-details-filters',
  templateUrl: './customer-details-filters.component.html',
})
export class CustomerDetailsFiltersComponent {
  public readonly customerDetailsFilter = model.required<ICustomerDetailsFilter>();
  public readonly dateFilterState = input<IProfileDateFilterState | null>(null);

  public readonly loading = input<boolean>(false);

  public readonly customerDetailsFilterChanged = output<ICustomerDetailsFilter>();
  public readonly dateRangeChanged = output<Pick<ICustomerDetailsFilter, 'endDate' | 'startDate'>>();
  public readonly selectedRangeChanged = output<EDateRangeType>();

  public onDateRangeChanged(dateRange: Pick<ICustomerDetailsFilter, 'endDate' | 'startDate'>): void {
    this.customerDetailsFilter.set({
      ...this.customerDetailsFilter(),
      endDate: dateRange.endDate,
      startDate: dateRange.startDate,
    });

    this.dateRangeChanged.emit(dateRange);
    this.customerDetailsFilterChanged.emit(this.customerDetailsFilter());
  }

  public onSelectedRangeChanged(selectedRange: EDateRangeType): void {
    this.selectedRangeChanged.emit(selectedRange);
  }
}
